<template>
	<div class="release_sdk">
		<document-title-bar :pathData="isPathData"></document-title-bar>
		<h1 class="doc_main_h1">视频人脸检测与识别</h1>
		<h3 class="doc_main_h3">（1）视频人脸检测与识别初始化</h3>
		<h3 class="doc_main_h3">功能描述</h3>
		<p class="doc_main_p">
			该接口为视频人脸检测与识别进行初始化。
		</p>
		<h3 class="doc_main_h3">函数</h3>
		<pre class="doc_main_pre"><code class="doc_main_code">public boolean SKFaceVideoTrackInit(int Width, int Height, int Model, boolean Mirroring, int Rotation , boolean EnableMemory)</code></pre>
        <h3 class="doc_main_h3">参数</h3>
        <p class="doc_main_p">（1）Width: 视频流数据宽度</p>
		<p class="doc_main_p">（2）Height: 视频流数据宽度</p>
		<p class="doc_main_p">（3）Model: 数据模式
			（0：基本模式。包含：人脸位置，人脸姿态(Yaw,Pitch,Roll)；   
				1：除上述基本模式外增加人脸属性(名字、性别、生日、备注信息)；
				2：除上述基本模式外增加人脸72关键点；
				3：除上述基本模式外增加人脸属性与人脸72个关键点）
		</p>
		<p class="doc_main_p">（4）Mirroring：是否需要内部镜像视频帧</p>
		<p class="doc_main_p">（5）Rotation：视频帧内部图像旋转
			（0：不旋转，默认值；
			1：顺时针旋转90度；
			2：顺时针旋转180度；
			3：顺时针旋转270度；）
		</p>
		<p class="doc_main_p">（6）EnableMemory：详见人脸记忆功能</p>
        <h3 class="doc_main_h3">返回值</h3>
        <p class="doc_main_p">boolean类型，视频初始化结果，成功为true，失败为false，成功后则可以调用视频人脸检测与跟踪。</p>
		<h3 class="doc_main_h3">示例代码</h3>
		<pre class="doc_main_pre"><code class="doc_main_code">boolean initRes = skFace.SKFaceVideoTrackInit(640, 480, 3 , false,0，false);</code></pre>
		<h3 class="doc_main_h3">（2）视频人脸检测与识别</h3>
		<h3 class="doc_main_h3">功能描述</h3>
		<p class="doc_main_p">
			对视频流的YUV数据进行人脸检测、跟踪、识别。调用该接口前必须成功调用SKFaceVideoTrackInit接口。该接口与图片人脸检测接口存在互斥，不可并行调用。
		</p>
		<h3 class="doc_main_h3">函数</h3>
		<pre class="doc_main_pre"><code class="doc_main_code">public FaceStruct[] SKFaceVideoTrackYUV(byte[] YUVData)</code></pre>
        <h3 class="doc_main_h3">参数</h3>
        <p class="doc_main_p">YUVData：视频帧的YUV数据（YUV格式：YUV_NV21 / YUV_NV12）</p>
        <h3 class="doc_main_h3">返回值</h3>
        <!--<p class="doc_main_p">人脸检测识别结果：数据结构（数组）。</p>-->
		<detection-structural-array></detection-structural-array>
		<h3 class="doc_main_h3">示例代码</h3>
		<pre class="doc_main_pre"><code class="doc_main_code">FaceStruct[] FaceStructs = skFace.SKFaceVideoTrackYUV(data);</code></pre>
	</div>
</template>
<script>
	import DocumentTitleBar from '../../../../components/documentTitleBar';
	import DetectionStructuralArray from '../../../../components/DetectionStructuralArray';
	export default{
		components:{
			'document-title-bar':DocumentTitleBar,
			'detection-structural-array':DetectionStructuralArray,
		},
		data(){
			return{
				isPathData:['人脸识别','SKFace-Android','基础接口','视频人脸检测与识别'],
			}
		},
		watch:{

		},
		methods:{

		},
		mounted(){

		}
	}
</script>
<style lang="less" rel="stylesheet/less">
	@import '../../../../less/index.less';
	.release_sdk{
	}
</style>	


// WEBPACK FOOTER //
// src/views/documents/skfacesdkandroid/basics/SkfaceSdkVideoDetectionRecognition.vue